<template>
  <div class="main-content py-4">
    <div class="container">
      <div class="row">
        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="batchRentBtnClicked">
            <img :src="require('@/assets/imgs/batch/batch_rent.png')" class="img-fluid"/>
            <label>批次借用</label>
          </b-button>
        </div>

        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="batchReturnBtnClicked">
            <img :src="require('@/assets/imgs/batch/batch_return.png')" class="img-fluid"/>
            <label>批次歸還</label>
          </b-button>
        </div>

        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="batchWashBtnClicked">
            <img :src="require('@/assets/imgs/batch/batch_wash.png')" class="img-fluid"/>
            <label>批次清洗</label>
          </b-button>
        </div>

        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="batchFillBtnClicked">
            <img :src="require('@/assets/imgs/batch/batch_fill.png')" class="img-fluid"/>
            <label>批次填充</label>
          </b-button>
        </div>

        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="batchWashAndFillBtnClicked">
            <img :src="require('@/assets/imgs/batch/batch_wash_and_fill.png')" class="img-fluid"/>
            <label>清洗填充</label>
          </b-button>
        </div>

        <div class="col-6 col-lg-3 col-xl-2 mb-4">
          <b-button variant="batch" @click="kegSearchBtnClicked">
            <img :src="require('@/assets/imgs/batch/keg_query.png')" class="img-fluid"/>
            <label>查看酒桶資訊</label>
          </b-button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegBatchIndex',
  data() {
    return {
      batchRentShow: false,
    };
  },
  components: {
  },
  computed: {

  },
  async mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    batchRentBtnClicked() {
      this.$router.push({name: 'kegBatchRent'});
    },
    batchReturnBtnClicked() {
      this.$router.push({name: 'kegBatchReturn'});
    },
    batchWashBtnClicked() {
      this.$router.push({name: 'kegBatchWash'});
    },
    batchFillBtnClicked() {
      this.$router.push({name: 'kegBatchFill'});
    },
    batchWashAndFillBtnClicked() {
      this.$router.push({name: 'kegBatchWashAndFill'});
    },
    kegSearchBtnClicked() {
      this.$router.push({name: 'kegSearchQuery'});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

.btn.btn-batch {
  border: solid 1px $color-black-500;
  border-radius: 1rem;
  padding: 1rem;
  background-color: transparent;
  >img {

  }
  >label {
    font-size: 1.2rem;
    font-weight: 800;
  }
}
</style>